import store from '@/store';
import { computed } from 'vue';

export const useAuthHeaders = () => {
   const getAuthHeaders = () => {
      const usuario = computed(() => store.state.auth.usuario);

      const access_token = sessionStorage.getItem('access_token');

      if (!access_token) {
         return { ok: false, message: 'No se encontró el token de acceso.' };
      }

      return {
         ok: true,
         config: {
            headers: {
               Authorization: access_token,
               id_empresa: usuario.value.id_empresa,
            },
         },
      };
   };

   return {
      getAuthHeaders,
   };
};